import { Provider } from 'jotai'
import React from 'react'

import { TableContent, type TableContentProps } from './components/TableContent'

export type TableProps<ColumnKey extends string> = TableContentProps<ColumnKey>

export const Table = React.forwardRef(
  <ColumnKey extends string>(
    props: TableProps<ColumnKey>,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => (
    <Provider>
      <TableContent ref={ref} {...props} />
    </Provider>
  ),
)
